import { Box, Chip, Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { getShortString } from 'lib/functions/utils';
import React from 'react';

interface OperationChipProps {
  requestId?: string;
  requestType?: string;
  maxLength?: number;
}

const OperationChip: React.FC<OperationChipProps> = ({
  requestId,
  requestType,
  maxLength = 14,
}) => {
  if (!requestId || !requestType) {
    return null;
  }

  const chipText = `${requestId}-${requestType}`;
  const truncatedText = getShortString(chipText, maxLength);
  const needsTooltip = chipText.length > maxLength;

  const chip = (
    <Chip
      label={truncatedText}
      size="small"
      color="primary"
      variant="outlined"
      sx={{ fontWeight: 'bold' }}
    />
  );

  return (
    <Box
      sx={{
        flexShrink: 0,
        display: 'flex',
        alignSelf: 'center',
      }}
    >
      {needsTooltip ? (
        <LightTooltip
          title={<Typography sx={{ padding: 1 }}>{chipText}</Typography>}
        >
          {chip}
        </LightTooltip>
      ) : (
        chip
      )}
    </Box>
  );
};

export default OperationChip;
